export default class IncidentTemplate {
  params: any;
  domRoot: HTMLElement;
  templateOutput: any;
  revealHide: HTMLElement;
  contentElement: HTMLElement;

  constructor(domRoot: HTMLElement, params: any) {
    this.params = params;
    this.domRoot = domRoot;
    this.templateOutput = params.templateOutput;
    this.revealHide = document.getElementById(params.revealId) as HTMLElement;
    this.contentElement = document.getElementById(params.contentId) as HTMLElement;
    this.init();
  }

  init() {
    this.domRoot.onsubmit = (e) => {
      e.preventDefault();
      this.generateText();
      return false;
    };
  }

  getValue(item, fieldID) {
    let fieldVal;
    if (item.getAttribute('data-itype') == "text") {
      fieldVal = item.children[1].value;
    } else if (item.getAttribute('data-itype') == "select") {
      fieldVal = item.children[1].value;
    } else {
      let fieldVals = document.getElementsByName(fieldID);
      for (let f = 0; f < fieldVals.length; f++) {
        if (fieldVals[f].checked) {
          fieldVal = fieldVals[f].value;
          break;
        }
      }
    }
    return fieldVal;
  }

  generateText() {
    let templateSelector = this.domRoot.querySelectorAll("[data-id='" + this.templateOutput + "']");
    let newOutput = this.getValue(templateSelector[0], this.templateOutput);
    let fields = this.domRoot.getElementsByClassName('incident-field');
    let errors  = 0;

    for (let i =  0; i < fields.length; i++) {
      let fieldI = fields[i];
      let fieldID = fieldI.getAttribute('data-id');
      let fieldVal = this.getValue(fieldI, fieldID);
      let stringReplace = "{" + fieldID + "}";
      let stringRegEx = new RegExp(stringReplace, "g");
      newOutput = newOutput.replace(stringRegEx, fieldVal);

      if (fieldVal == undefined || fieldVal == null || fieldVal == "null" || fieldVal == "") {
        errors++;
        fieldI.classList.add('with-error');
      } else {
        fieldI.classList.remove('with-error');
      }
    }

    if (errors == 0) {
      this.revealHide.style.display = "block";
      this.contentElement.innerHTML = `<div class="incident--output">
        <textarea id="get-incident">${newOutput}</textarea>
        <p>${newOutput}</p>
        <button id="generate-another" class="button button--small button--one button--primary">
        ${this.params.generateAnother}
        </button>
        <button id="copy-incident-text" class="button button--small button--one button--secondary">
        ${this.params.copyTemplate}
        </button>
      </div>`;

      document.getElementById("generate-another").addEventListener("click", () => {
        window.scrollTo(0, this.offsetTopFind(this.domRoot) - 70);
        this.revealHide.style.display = "none";
      });
      document.getElementById("copy-incident-text").addEventListener("click", (e) => {
        document.getElementById("get-incident").select();
        document.execCommand("copy");
        e.target.classList.add("copied");
        setTimeout(() => {
          e.target.classList.remove("copied");
        }, 2000);
      });
      this.smoothScroll(this.revealHide);
    } else {
      this.revealHide.style.display = "none";
    }
  }

  smoothScroll(item) {
    let initialScroll = window.scrollY;
    let itemPosition = item.offsetTop - 70;
    let increment = (initialScroll - itemPosition) * 0.02;
    let delay = 1000 / increment;
    let scrollInterval = setInterval(winScroll, delay);
    function winScroll() {
      if (Math.abs(initialScroll - itemPosition) > 100) {
        initialScroll = initialScroll - increment;
        window.scrollTo(0, initialScroll);
      } else {
        clearInterval(scrollInterval);
      }
    }
  }

  offsetTopFind(el, withHeight = 0) {
    let yPosition = withHeight;
    while (el.offsetParent !== null) {
      yPosition += el.offsetTop;
      el = el.offsetParent;
    }
    return yPosition;
  }
}
